// Centralise toutes les infos de marque pour le site public
export const SITE = {
  name: "FB Environnement",
  tagline: "Centre de recyclage",
  punchline: "Une solution simple pour vos déchets professionnels",
  address: {
    street: "30 chemin de la Carrère",
    postal: "13730",
    city: "Saint-Victoret",
    full: "30 chemin de la Carrère, 13730 Saint-Victoret",
  },
  phone: "07 83 48 15 72",
  phoneRaw: "+33783481572",
  email: "contact@fbenvironnement.fr",
  hours: [
    { d: "Lundi → Vendredi", h: "7h — 17h", note: "non-stop" },
  ],
  colors: {
    darkGreen: "#1F6B2E",
    limeGreen: "#9DCB2E",
  },
  social: {},
};
